import { VEHICLES_FETCHING, VEHICLES_FAILED, VEHICLES_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case VEHICLES_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case VEHICLES_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case VEHICLES_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}